export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9505.c0ab9f9c.jpg";